import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import MenuLink from './MenuLinkLarge';
import SubMenu from './SubMenuLarge';
import { MAIN_NAV_MAIN_MENU_LIST } from '../../../constants/z-index-map';
import { arrowRightBlueberry, caratDownBlueberry } from '../../../util/icons';
import { NAVIGATION_BREAKPOINT } from '../../../constants/layout';
import { Link } from 'gatsby';
import * as colors from '../../../util/colors';
import { Text } from '../../../util/typography';

const MainMenuList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: none;
    position: relative;
    @media (min-width: ${NAVIGATION_BREAKPOINT}) {
        flex: 9 2 auto;
        display: flex;
        justify-content: flex-end;
        z-index: ${MAIN_NAV_MAIN_MENU_LIST};
        ${({ brandType }) =>
      brandType !== "keytrudahcp" ? "max-width: 564px;" : ""}
    }
`;

const StyledMainMenuItem = styled.li`
    flex: 0 1 160px;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: stretch;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;       
`;

const QSubMenuLink = styled(Link)`
    padding: 1em 1em 0px;
    display: flex;
    flex: 1 1 auto;
    max-width:141px;
    flex-flow: column nowrap;
    text-align:center;
    justify-content: center;
    align-items:center;
    text-decoration: none;
    color:${colors.charcoal};
    background-color: ${colors.white};
    transition: background-color 0.3s ease-in-out;
    box-sizing: border-box;
    height: 100%;
    z-index: 1;
    border: none;
    position: relative;
            
            &::after {
                display: block;
                content: "";
                margin-top: 6px;
                width: 10px;
                height: 10px;
                background-image: url(${caratDownBlueberry});
                transform: rotate(0deg);
                background-repeat: no-repeat;
                background-position: center, left;
                background-size: contain;
                transition: background-position-y .3s ease-in-out;
                margin-bottom: 13px;
            }

    &:hover {
        // background-color: ${colors.mist};
             &::after {
                animation-duration: 0.3s;
                animation-name: menu-arrowDown-animation;
                animation-fill-mode: both;
            }
         @keyframes menu-arrowDown-animation {
        0% {
            background-position: center 50%, left;
        }

        50% {
            background-position: calc(100% + 20px) center, center;
        }

        50.001% {
            background-position: calc(0% - 20px) center, center;
        }

        100% {
            background-position: center 50%, right;
        }
    }

    }
    @media (max-width:${NAVIGATION_BREAKPOINT}){
        max-width: 100%;
        flex-flow: row;
        justify-content: space-between;
        padding: 12px 20px 12px 16px;
        border-left: 4px solid transparent;
        color:${colors.ink};
    }
`;

const QSubAnchorLink = styled.a`
  /* same styles as QSubMenuLink */
  padding: 1em 1em 0px;
  display: flex;
  flex: 1 1 auto;
  max-width:141px;
  flex-flow: column nowrap;
  text-align:center;
  justify-content: center;
  align-items:center;
  text-decoration: none;
  color:${colors.charcoal};
  background-color: ${colors.white};
  transition: background-color 0.3s ease-in-out;
  box-sizing: border-box;
  height: 100%;
  z-index: 1;
  border: none;
  position: relative;

  &::after {
    display: block;
    content: "";
    margin-top: 6px;
    width: 10px;
    height: 7px;
    background-image: url(${caratDownBlueberry});
    transform: rotate(0deg);
    background-repeat: no-repeat;
    background-position: center, top;
    background-size: contain;
    transition: background-position-y .3s ease-in-out;
    margin-bottom: 13px;
  }

  &:hover {
  @media (min-width: ${NAVIGATION_BREAKPOINT}){
    background-color: ${colors.mist};
  }
    &::after {
      animation-duration: 0.3s;
      animation-name: menu-arrowDown-animation;
      animation-fill-mode: both;
    }

    @keyframes menu-arrowDown-animation {
        0% {
            background-position: center top;
        }
        50% {
            background-position: center calc(50% + 20px);
        }
        50.001% {
            background-position: center calc(50% - 20px);
        }
        100% {
            background-position: center bottom;
        }
        }
  }

  @media (max-width:${NAVIGATION_BREAKPOINT}){
    max-width: 100%;
    flex-flow: row;
    justify-content: space-between;
    padding: 12px 20px 12px 16px;
    border-left: 4px solid transparent;
    color:${colors.ink};
  }
`;

const QSubMenuLable = styled(Text.Button)`
    line-height: 18px;
    font-weight: 500;
    flex: 0 auto;
    color: inherit;
`;

const MainMenuItem = ({ className, clickHandler, item, isLast, isOpen, brandType }) => {
    const parentItem = useRef(null);
    const [topItemLeftOffset, setTopItemLeftOffset] = useState(0);
    const [topItemWidth, setTopItemWidth] = useState(0);

    const topItemClickHandler = () => {
        setTopItemLeftOffset(parentItem.current.offsetLeft);
        setTopItemWidth(parentItem.current.offsetWidth);
        clickHandler();
    };

    return (
        <StyledMainMenuItem
            ref={parentItem}
            onClick={clickHandler ? topItemClickHandler : ''}
        >
            <MenuLink
                level="1"
                label={item.label}
                url={item.url}
                hasChildren={item.children && item.children.length > 0}
                isOpen={isOpen}
                activePath={item.activePath}
                aria-expanded={isOpen}
                brandType={brandType}
            />
            {item.children && (
                <SubMenu
                    isOpen={isOpen}
                    isLast={isLast}
                    items={item.children}
                    leftOffset={topItemLeftOffset}
                    width={topItemWidth * 2}
                />
            )}
        </StyledMainMenuItem>
    );
};

export const QsubMainMenuItem = ({ item }) => {
    const isAnchor = item.url.startsWith('#');
    return isAnchor ? (
        <QSubAnchorLink href={item.url}>
            <QSubMenuLable>{item.label}</QSubMenuLable>
        </QSubAnchorLink>
    ) : (
        <QSubMenuLink to={item.url} activePath={item.activePath}>
            <QSubMenuLable>{item.label}</QSubMenuLable>
        </QSubMenuLink>
    );
    // return (
    //     <QSubMenuLink to={item.url} activePath={item.activePath}>
    //         <QSubMenuLable>{item.label}</QSubMenuLable>
    //     </QSubMenuLink>
    // )
}

const MainMenuLarge = ({ items, openItem, clickHandler, closeAllHandler, styled_nav_ref, brandType }) => (
    <MainMenuList ref={styled_nav_ref} brandType={brandType} >
        {items.map((item, i) => (
            // brandType === "keytrudahcp" ?
                <MainMenuItem
                    key={i}
                    clickHandler={!item.url ? () => clickHandler(i, openItem) : closeAllHandler}
                    item={item}
                    isLast={i === items.length - 1}
                    isOpen={openItem === i}
                    brandType = {brandType}
                /> 
                // :
                // <QsubMainMenuItem
                //     key={i}
                //     item={item}
                // />
        ))}
    </MainMenuList>
);

export default MainMenuLarge;
